var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 10,
    viewBox: "0 0 20 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4419_6378)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9992 5.5C19.9992 5.8 19.8992 6 19.8992 6.3C19.3992 8.3 17.6992 9.8 15.5992 10C15.0992 10 14.5992 10 14.0992 10C13.1992 10 12.3992 10 11.4992 10C10.9992 10 10.6992 9.7 10.6992 9.3C10.6992 8.9 10.9992 8.5 11.4992 8.5C12.6992 8.5 13.8992 8.5 15.1992 8.5C16.7992 8.5 18.1992 7.2 18.3992 5.6C18.6992 3.7 17.5992 2 15.6992 1.6C15.3992 1.5 15.0992 1.5 14.8992 1.5C13.7992 1.5 12.6992 1.5 11.5992 1.5C11.0992 1.5 10.8992 1.3 10.7992 0.9C10.6992 0.5 10.9992 0 11.4992 0C12.7992 0 14.0992 0 15.3992 0C17.5992 0.1 19.5992 1.9 19.9992 4.1C19.9992 4.2 19.9992 4.3 19.9992 4.5C19.9992 4.8 19.9992 5.2 19.9992 5.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.60004 10C6.00004 10 5.50004 10 5.00004 10C2.60004 10 0.600037 8.3 0.100037 6C-0.499963 2.8 1.70004 0.5 4.00004 0.1C4.30004 0.1 4.60004 0 4.80004 0C6.00004 0 7.20004 0 8.50004 0C8.90004 0 9.20004 0.3 9.30004 0.7C9.30004 1.1 9.10004 1.4 8.60004 1.5C8.50004 1.5 8.40004 1.5 8.30004 1.5C7.20004 1.5 6.10004 1.5 5.00004 1.5C3.20004 1.5 1.70004 2.8 1.50004 4.5C1.30004 6.4 2.60004 8.2 4.40004 8.4C4.60004 8.4 4.90004 8.5 5.10004 8.5C6.20004 8.5 7.20004 8.5 8.30004 8.5C8.40004 8.5 8.60004 8.5 8.70004 8.5C9.10004 8.7 9.30004 9 9.30004 9.4C9.20004 9.7 8.90004 10 8.50004 10C7.90004 10 7.20004 10 6.60004 10Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0005 5.79688C9.00045 5.79688 7.90045 5.79688 6.90045 5.79688C6.60045 5.79688 6.30045 5.69687 6.20045 5.39687C6.10045 5.09687 6.10045 4.79687 6.30045 4.59687C6.40045 4.39687 6.60045 4.29688 6.80045 4.29688H6.90045C8.90045 4.29688 11.0005 4.29688 13.0005 4.29688C13.5005 4.29688 13.8005 4.59687 13.8005 4.99687C13.8005 5.39687 13.5005 5.79688 13.1005 5.79688C12.6005 5.79688 12.2005 5.79688 11.7005 5.79688C11.2005 5.79688 10.6005 5.79688 10.0005 5.79688Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4419_6378"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyImg);
export default __webpack_public_path__ + "static/media/copy-img.95061e0465ff54a30b1aad6b98c98670.svg";
export { ForwardRef as ReactComponent };